// exportFailure — what the author can do after an export failed, pure.
//
// FR-10.3: a material that cannot be exported says why and what to change.
// The why and the fix come from `toDisplay` (title + body); this picks the
// ONE next step the export dialog offers, from the display's recovery.

import { exhaustSwitchCase } from "@bilda/utils";
import type { Recovery } from "./externalError.js";

export type ExportNextStep =
    // A transient failure: packaging the same format again may work.
    | "try-again"
    // The material (or the session) must change first: back to it.
    | "change-material";

export const exportNextStep = (recovery: Recovery): ExportNextStep => {
    switch (recovery) {
        case "Retry":
        case "Reload":
            return "try-again";
        case "ReAuth":
        case "GoBack":
        case "FixInput":
        case "FixConfig":
        case "None":
            return "change-material";
        default:
            return exhaustSwitchCase(recovery);
    }
};
